import styled from 'styled-components'

import { mainColors } from '../../styles/colors'
import { _S_Medium } from '../../styles/typography'

export const Calendar = styled.div`
  display: inline-flex;
  flex-direction: column;
  padding: 12px;
  background: ${mainColors.white};
`

export const Body = styled.div`
  display: flex;
  gap: 24px;
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`

export const ColumnHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 8px;
`

export const MonthLabel = styled.div`
  ${_S_Medium};
  color: ${mainColors.neutralExtremelyDark};
`

export const NavButton = styled.button`
  appearance: none;
  border: none;
  background: transparent;
  cursor: pointer;
  color: ${mainColors.neutralExtraDark};
  font-size: 18px;
  line-height: 1;
  padding: 0 4px;

  &:hover {
    color: ${mainColors.accentMedium};
  }
`

export const Spacer = styled.span`
  width: 20px;
`
